<template>
  <div class="traveller row vh-align">
    <div class="icon col-2">
      <fa fa-class="user"
          :solid="false"
      />
    </div>
    <div class="details col-10">
      <div class="name">
        {{ getGender }} {{ contact.firstName || contact.first_name|capitalise }} {{ contact.lastName || contact.last_name|uppercase }}
      </div>
      <div v-if="contact.email"
           class="email"
      >
        {{ contact.email|lowercase }}
      </div>
      <div v-if="contact.mobilePhone || contact.mobile_phone"
           class="tel"
      >
        {{ getTel }}
      </div>
    </div>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  components: {
    fa
  },
  mixins: [formatter],
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  created () {
    this.contact = this.contact.traveller || this.contact
  },
  computed: {
    getGender () {
      return this.formatGender(this.contact.gender)
    },
    getTel () {
      return this.formatPhoneNumber(this.contact.mobilePhone || this.contact.mobile_phone)
    }
  }
}
</script>
